import { render, staticRenderFns } from "./HallModal.vue?vue&type=template&id=20d09930&lang=pug&"
import script from "./HallModal.vue?vue&type=script&lang=js&"
export * from "./HallModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports